import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const upcomingProductsFromSomeoneElseFeatureKey = 'upcomingProductsFromSomeoneElse';

export interface UpcomingProductsFromSomeoneElseState {
  loadUpcomingProductsFromSomeoneElseResponse: IProducts[];
  loadUpcomingProductsFromSomeoneElseFailure: Error | any;
}

export const initialState: UpcomingProductsFromSomeoneElseState = {
  loadUpcomingProductsFromSomeoneElseResponse: undefined,
  loadUpcomingProductsFromSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadUpcomingProductsFromSomeoneElse, (state, action) => ({
    ...state
  })),
  on(actions.loadUpcomingProductsFromSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadUpcomingProductsFromSomeoneElseResponse: action.response
  })),
  on(actions.loadUpcomingProductsFromSomeoneElseFailure, (state, action) => ({
    ...state,
    loadUpcomingProductsFromSomeoneElseFailure: action.error
  }))
);

export const getUpcomingProductsFromSomeoneElseResponse = (state: UpcomingProductsFromSomeoneElseState) =>
  state.loadUpcomingProductsFromSomeoneElseResponse;
